<template>
  <!-- countDownの形式 00:00:00:00 day:hour:min:sec -->
  <!-- 表示は 00:00 hours:min:sec -->
  <div class="timer" v-if="countDown">
    あと
    <template v-if="hours != '00'"><span>{{ hours }}</span>時間</template>
    <span>{{ minutes }}</span>分
    <span>{{ seconds }}</span>秒
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  name: "FaceCountDown",
  props: {
    countDown: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const hours = computed(() => props.countDown.split(":")[1]);
    const minutes = computed(() => props.countDown.split(":")[2]);
    const seconds = computed(() => props.countDown.split(":")[3]);

    return {
      hours,
      minutes,
      seconds,
    }
  }
};
</script>

<style lang="scss" scoped>
.timer {
  position: absolute;
  z-index: 1;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  font-size: 10px;
}

.timer span {
  margin: 0 10px 3px 10px;
  font-size: 30px;
  font-weight: bold;
}
</style>
